import { useState, useEffect } from "react";
import KPIs from "./KPI";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import "./Table.css";
import drag from "../images/drag.png";
import { t } from "i18next";
import orderNr from "../images/orderNr.png";
import width from "../images/width.png";
import color from "../images/color.png";
import dueDate from "../images/dueDate.png";
import endTime from "../images/endTime.png";
import sigma from "../images/sigma.png";
import setupTime from "../images/setupTime.png";

function KPIsOrders (props) {

    const [data, setData] = useState(props.data);

    let isMobile = props.isMobile;

    function handleDragEnd (result) {
      const { destination, source } = result;
  
      // Überprüfen, ob ein gültiges Ziel vorhanden ist
      if (!destination) {
        return;
      }
  
      // Überprüfen, ob sich die Position geändert hat
      if (destination.index === source.index) {
        return;
      }

      data.splice(
        destination.index,
        0,
        data.splice(source.index, 1)[0],
      );
      setData([...data]);
      props.startTime();
    };
  
    function onDragStart() {
      if (window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }
    }

    useEffect(() => {
        props.calc();
        setData(props.data);
      }, [data]);

    return (
      <div className="table-responsive dnd-wrapper">
        <KPIs score={data.score} dueDateViolations={data.dueDateViolations} setupDur={data.setupDur}></KPIs>
        <DragDropContext onDragEnd={handleDragEnd} onDragStart={onDragStart}>
          {isMobile ?
            <Droppable droppableId="droppable-2">
              {(provider) => (
                <div ref={provider.innerRef} {...provider.droppableProps}>
                  {data.map((order, index) => (
                    <Draggable key={order.orderNr} draggableId={order.orderNr.toString()} index={index}>
                      {(provider) => (
                        <div className="card" {...provider.draggableProps} ref={provider.innerRef} {...provider.dragHandleProps}>
                          <div className="card-body p-1">
                            <ul className="list-group list-group-horizontal row gy-1">
                              <li className="list-group-item p-0 value col">
                                <img src={orderNr} width={20} height={20} alt="orderNr" />
                                <p>{order.orderNr}</p>
                              </li>
                              <li className="list-group-item p-0 value col" >
                                <img src={width} width={20} height={20} alt="width" />
                                <p>{order.width}</p>
                              </li>
                              <li className="list-group-item p-0 value col" >
                                <img src={color} width={20} height={20} alt="color" />
                                {order.color.props.children === "Blau" ? <p><mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>{t("blue")}</mark></p> 
                                  : order.color.props.children === "Violett" ? <p><mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>{t("violet")}</mark></p> 
                                  : <p><mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>{t("green")}</mark></p>}
                              </li>
                              <li className="list-group-item p-0 value col">
                                <img src={dueDate} width={20} height={20} alt="dueDate" />
                                <p>{order.dueDate}</p>
                              </li>
                            </ul>
                            <ul className="list-group list-group-horizontal row gy-1">
                              <li className="list-group-item p-0 value col">
                                <img src={width} width={20} height={20} alt="width" />
                                <img src={setupTime} width={20} height={20} alt="setupTime" />
                                <p>{order.widthSetupDur}</p>
                              </li>
                              <li className="list-group-item p-0 value col">
                                <img src={color} width={20} height={20} alt="color" />
                                <img src={setupTime} width={20} height={20} alt="setupTime" />
                                <p>{order.colorSetupDur}</p>
                              </li>
                              <li className="list-group-item p-0 value col">
                                <img src={sigma} width={15} height={15} alt="sigma" />
                                <img src={setupTime} width={20} height={20} alt="setupTime" />
                                <p>{order.totalSetupDur}</p>
                              </li>
                            </ul>
                            <ul className="list-group list-group-horizontal row gy-1">
                              <li className="list-group-item p-0 value col">
                                <p>{order.moveUp}</p>
                              </li>
                              <li className="list-group-item p-0 value col">
                                <img src={endTime} width={20} height={20} alt="endTime" />
                                <p>{order.endTime}</p>
                              </li>
                              <li className="list-group-item p-0 value col">
                                <p>{order.isOnTime}</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provider.placeholder}
                </div>
              )}
            </Droppable>
            :
            <Droppable droppableId="droppable-1">
            {(provider) => (
              <table ref={provider.innerRef} {...provider.droppableProps} className="table table-sm table-hover table-bordered table-dnd">
                <thead>
                  <tr>
                    <th></th>
                    <th>{t("isOnTime")}</th>
                    <th>{t("orderNr")}</th>
                    <th>{t("width")}</th>
                    <th>{t("color")}</th>
                    <th>{t("moveUp")}</th>
                    <th>{t("dueDate")}</th> 
                    <th>{t("endTime")}</th>
                    <th>{t("totalSetupDur")}</th>
                    <th>{t("colorSetupDur")}</th>
                    <th>{t("widthSetupDur")}</th>
                  </tr>                  
                </thead>
                <tbody>
                  {data.map((order, index) => (
                    <Draggable key={order.orderNr} draggableId={order.orderNr.toString()} index={index} >
                      {(provider) => (
                        <tr {...provider.draggableProps} ref={provider.innerRef} {...provider.dragHandleProps}>
                          <td width={29}><img src={drag} width={20} height={20} alt="drag" /></td>
                          <td width={72}>{order.isOnTime}</td>
                          <td width={64}>{order.orderNr}</td>
                          <td width={50}>{order.width}</td>
                          {order.color.props.children === "Blau" ? <td width={55}><mark style={{color: "blue", backgroundColor: "transparent", fontWeight: 800}}>{t("blue")}</mark></td> 
                            : order.color.props.children === "Violett" ? <td width={55}><mark style={{color: "#9C33FF", backgroundColor: "transparent", fontWeight: 800}}>{t("violet")}</mark></td> 
                            : <td width={55}><mark style={{color: "green", backgroundColor: "transparent", fontWeight: 800}}>{t("green")}</mark></td>}
                          <td width={64}>{order.moveUp}</td>
                          <td width={67}>{order.dueDate}</td>
                          <td width={125}>{order.endTime}</td>
                          <td width={105}>{order.totalSetupDur}</td>
                          <td width={108}>{order.colorSetupDur}</td>
                          <td width={113}>{order.widthSetupDur}</td>
                        </tr>
                      )}
                    </Draggable>
                  ))}
                  {provider.placeholder}
                </tbody>
              </table>
            )}
          </Droppable>
          }
        </DragDropContext>
      </div>
    );
}

export default KPIsOrders;